import { myNewsletterUnsubscription } from './myNewsletterUnsubscription';

require('./myNewsletterUnsubscription.scss');

export const myNewsletterUnsubscriptionComponent = {
  template: require('./myNewsletterUnsubscription.html'),
  controllerAs: 'ctrl',
  controller: myNewsletterUnsubscription,
};
